import { IBaseDeleteRequestModel } from "../models/request/base/deleteRequest";
import { sf_dotdangky_dichvu } from "../models/response/category/sf_dotdangky_dichvu";
import { apiClient } from "./apiClient";

export const SF_DOTDANGKYDICHVU_SELECT_ALL_API = "sf_dotdangky_dichvu/select_all";
export const SF_DOTDANGKYDICHVU_INSERT_API = "sf_dotdangky_dichvu/insert";
export const SF_DOTDANGKYDICHVU_UPDATE_API = "sf_dotdangky_dichvu/update";
export const SF_DOTDANGKYDICHVU_DELETE_API = "sf_dotdangky_dichvu/delete";
export const SF_DOTDANGKYDICHVU_SELECT_ALL_BY_COSO = "sf_dotdangky_dichvu/select_all_by_coso";
export const SELECT_KHOAN_NOP_BY_DOT = "sf_dotdangky_dichvu/select_khoan_nop_group_by_dot";
export const SELECT_KHOAN_NOP_BY_DOTDANGKY = "sf_dotdangky_dichvu/select_khoan_nop_group_by_dotdangky";

export const dotDangKyDichVuApi = {
    select_all: () => {
        return apiClient.post(SF_DOTDANGKYDICHVU_SELECT_ALL_API)
    },
    insert: (data: sf_dotdangky_dichvu) => {
        return apiClient.post(SF_DOTDANGKYDICHVU_INSERT_API, data)
    },
    update: (data: sf_dotdangky_dichvu) => {
        return apiClient.post(SF_DOTDANGKYDICHVU_UPDATE_API, data)
    },
    delete: (data: number[]) => {
        const model: IBaseDeleteRequestModel = {
            ids: data
        }
        return apiClient.post(SF_DOTDANGKYDICHVU_DELETE_API, model)
    },
    select_all_by_coso: (data: sf_dotdangky_dichvu) => {
        return apiClient.post(SF_DOTDANGKYDICHVU_SELECT_ALL_BY_COSO, data)
    },
    select_khoan_nop_group_by_dot: (data: sf_dotdangky_dichvu) => {
        return apiClient.post(SELECT_KHOAN_NOP_BY_DOT, data)
    },
    select_khoan_nop_group_by_dotdangky: (sf_dotdangky_dichvu_id: number) => {
        return apiClient.post(`${SELECT_KHOAN_NOP_BY_DOTDANGKY}?sf_dotdangky_dichvu_id=${sf_dotdangky_dichvu_id}`)
    },
}